import axios from 'axios'

const http = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API
})

const state = {
    devices: null,
    deviceId: localStorage.getItem('deviceId') || null,
    deviceCode: localStorage.getItem('deviceCode') || null
}

const getters = {
    getDeviceId: state => state.deviceId,
    getDeviceCode: state => state.deviceCode,
    isDeviceRegistered: state => (state.deviceId && state.deviceCode)
}

const actions = {
    loadRegisteredDevice: () => {
        console.log(localStorage.getItem('deviceId'))
        console.log(localStorage.getItem('deviceCode'))
    },
    fetchDevices: ({commit}) => {
        http({
            method: "get",
            url: `/smiley-tools/devices`
        }).then((res) => {
            commit('setDevices', res.data.results)
        })
    },
    fetchDeviceById: (context, id) => {
        http({
            method: "get",
            url: `/smiley-tools/devices/${id}`
        }).then((res) => {
            console.log(res)
        })
    },
    fetchDeviceByCode: (context, code) => {
        return http({
            method: "get",
            url: `/smiley-tools/devices/?token=${code}`
        }).then((res) => {
            if (res.data.count == 1) {
                return {
                    id: res.data.results[0].id,
                    code: res.data.results[0].token,
                    locationId: res.data.results[0].location_id,
                    locationName: res.data.results[0].location.name
                }
            }
            return null
        })
    }
}

const mutations = {
    setDevices: (state, devices) => {
        state.devices = devices
    },
    setDeviceId: (state, id) => {
        state.deviceId = id
    },
    setDeviceCode: (state, code) => {
        state.deviceCode = code
    },
    registerDevice: (state, {id, code}) => {
        state.deviceId = id
        state.deviceCode = code
        localStorage.setItem('deviceId', id)
        localStorage.setItem('deviceCode', code)
    },
    reset: (state) => {
        state.deviceId = null
        state.deviceCode = null
        localStorage.removeItem('deviceId')
        localStorage.removeItem('deviceCode')
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
